import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { PaymentServiceWithVersionsResponseType } from '../../../../api/types/payments/payment-template';
import { PaymentServicesFilterType } from '../payment-services-filter.type';

// Backend Joi: paymentServiceName has min(2). Anything shorter is treated as
// "no filter" so the user can type freely without triggering 400 errors.
const PAYMENT_SERVICE_NAME_MIN_LENGTH = 2;

export const getPaymentServicesListOperation = async (
  filters: PaymentServicesFilterType,
  offset: number,
  limit: number,
  setData: (data: PaymentServiceWithVersionsResponseType[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const trimmedName = filters.paymentServiceName?.trim() ?? '';
    const normalizedName =
      trimmedName.length >= PAYMENT_SERVICE_NAME_MIN_LENGTH
        ? trimmedName
        : null;

    const res = await appApi.getPaymentServicesList({
      offset,
      limit,
      paymentServiceName: normalizedName,
      priceFrom: filters.priceFrom ?? null,
      priceTo: filters.priceTo ?? null,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body?.data ?? []);
    setTotal(res.data.body?.total ?? 0);
    setLoading(false);
  } catch (e) {
    console.error(`getPaymentServicesListOperation failed with error: ${e}`);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
